export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0003_Ziv-impact.7aeae552.png";